import map from 'lodash/map'
import { IApplicationState } from '@Site/rootReducer'

import { createSelector } from 'reselect'

import {
  IVocabulary,
} from './types'

export const getVocabularies = (state: IApplicationState): IVocabulary[] => state.vocabularies.vocabularies
export const getVocabulariesLoading = (state: IApplicationState): boolean => state.vocabularies.loading
export const getVocabulariesHasLoadedInitially = (state: IApplicationState): boolean => state.vocabularies.hasLoadedInitially

export const getVocabularyNames = createSelector(
  [getVocabularies],
  (vocabularies) => map(vocabularies, vocabulary => vocabulary.attributes.name)
)

export const getVocabularyIds = createSelector(
  [getVocabularies],
  (vocabularies) => map(vocabularies, vocabulary => vocabulary.id)
)
